import { JSX } from "react";

import MovieCard from "@/components/cards/MovieCard";
import Carousel from "@/components/helpers/Carousel.tsx";

import { Content } from "@/@types/general.ts";
import { isMobile } from "@/utils/constatns";

interface MoviesSectionSliderProps {
  contents: Content[];
  sectionName: string;
}

const MoviesSectionSlider = ({ sectionName, contents }: MoviesSectionSliderProps): JSX.Element => {
  return (
    <Carousel<Content>
      swiperParams={{
        slidesPerView: 2,
        spaceBetween: 16,
        followFinger: isMobile,
        breakpoints: {
          640: { slidesPerView: 3, slidesPerGroup: 3 },
          1024: { slidesPerView: 4, slidesPerGroup: 4 },
          1280: { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 12 },
          1440: { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 16 },
        },
      }}
      items={contents}
      swiperName={sectionName}
    >
      {(content) => <MovieCard key={content.id} {...content} />}
    </Carousel>
  );
};

export default MoviesSectionSlider;
